import { Injectable } from '@angular/core';
import { FilterService } from '../services/filter.service';
import { PickupQuery } from '../../../models/pickup-query';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class PickupFilterService extends FilterService<PickupQuery> implements FilterAssistQuery<PickupQuery> {

    private PICKUP_FILTER = 'PICKUP_FILTER';

    constructor() {
        super();
        this.registerFilters(this);
    }

    protected describe(terms: string): string {
        return $localize`Filter for "${terms}"`;
    }

    active(query: PickupQuery): Observable<FilterAssist[]> {
        if (query.reference) {
            return of([ {
                id: this.PICKUP_FILTER,
                description: this.describe(query.reference),
                score: 50,
                parameter: query.reference,
                category: FilterCategoryEnum.ANY
            } ]);
        }
        return of([]);
    }

    apply(id: string, parameter: any, query: PickupQuery): void {
        switch (id) {
            case this.PICKUP_FILTER:
                query.reference = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.PICKUP_FILTER ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return of([ {
            id: this.PICKUP_FILTER,
            parameter: terms,
            score: 50,
            description: this.describe(terms),
            category: FilterCategoryEnum.ANY
        } ]);
    }

    unapply(id: string, query: PickupQuery): void {
        switch (id) {
            case this.PICKUP_FILTER:
                query.reference = null;
                break;
        }
    }
}
